import { Component, EventEmitter, HostBinding, OnInit, Output, Input } from '@angular/core';
import { MUser } from '@argalis-apps/models';
import { Subject } from 'rxjs';
import { chevronLeftIcon, chevronRightIcon, SVGIcon } from '@progress/kendo-svg-icons';

@Component({
  selector: 'ags-extranet-sidemenu',
  templateUrl: './extranet-sidemenu.component.html',
  styleUrls: ['./extranet-sidemenu.component.scss']
})
export class ExtranetSidemenuComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  @Input() themingClassName;
  @Input() userChange: Subject<MUser.CUser>;
  @Input() menu: Array<{
    libelle: string;
    routerLink: string;
    icon: string;
    badgeNumber?: number;
  }>;
  @Input('notificationNumber')
  set _notificationNumber(notifs: number) {
    this.notificationNumber = Number(notifs || 0);
  }

  @Output() sidebarIsClosed = new EventEmitter<boolean>();

  private userConnected: MUser.CUser = null;
  public isSideBarClosed = false;
  public addTextAnimation = false;
  public isInternetExplorer: boolean = void 0;
  public notificationNumber: number;
  public svgFilterClear: SVGIcon = chevronLeftIcon;

  constructor() {
    this.isInternetExplorer = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1;
  }

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.themingClassName}`;
    this.userChange.subscribe((user: MUser.CUser) => {
      this.userConnected = user;
    });
  }

  toggleSidebar() {
    this.isSideBarClosed = !this.isSideBarClosed;
    this.addTextAnimation = !this.isSideBarClosed;
    this.svgFilterClear = this.isSideBarClosed ? chevronRightIcon : chevronLeftIcon;
    this.sidebarIsClosed.emit(this.isSideBarClosed);
  }
}
